<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div v-if="!submitLoading && !submitSuccess && !sequentialHasFailures" class="modal-container" :style="endpoint?.includes('administ') ? 'min-width: 45rem; width: 45rem' : 'min-width: 35rem; width: 35rem'">
                <div class="modal-header">
                    <slot name="header">
                        <div>
                            <h3 class="form-header">{{ endpoint == '/drug-safe-retrieval' || (drugReg && drugReg.length) ? 'Remove from Register' : 'Signature \
                            Verification'}}</h3>
                        </div>
                        <!-- $emit(isSuccessful, true) -->
                        <button @click="closeModal()" class="red-close-button"
                            style="width: 30px !important">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body" style="padding-bottom: 20px; text-align: left; max-height: 60vh; overflow-y: auto; overflow-x: hidden;">
                    <slot name="body">
                        <!-- WARNING -->
                        <div v-if="warning"
                            style="color: #E04F39; width: fit-content; margin: 0 auto; margin: 1em auto; display: flex; align-items: center;">
                            <i class="pi pi-exclamation-circle" style="font-size: 2em !important"></i>
                            <h4 style="margin: 0; font-weight: normal">{{ warning }}</h4>
                        </div>
                        <!-- WARNING -->
                        <p style="margin-left: 20px;">Note: Closing this modal will not save any signatures or notes.</p>
                        
                        <!-- To choose between signing as primary or witness -->
                        <div class="calenderdatelabel singleSignature" v-if="$store.state.company.type == 'warehouse' && (this.dualForMeds || this.dual) && (isStatus?.status ? false : isWarehouse) && ($store.state.user.role.permissions.includes('signature_primary') && $store.state.user.role.permissions.includes('signature_witness')) ? true : false && !signature_1 && !success1 && !signature_2 && !success2">
                            <label for="primarySignature">Countersign mode</label>
                            <InputSwitch id="primarySignature" v-model="signPrimarySignature"/>
                        </div>
                        

                        <!-- SIGN WARNING  -->
                        <p style="color: red; font-weight: 500; font-size: 1em;text-align: center; margin: 0"
                            v-if="sig2.name && sig1.name && ($store.state.company.type == 'warehouse' ? verifyBulkOrSignleForWarehouse() : sig2.name == sig1.name)">{{ signError }}</p>
                        <p :style="isQueued ? 'color: #ff9800;' : 'color: red;'" style="font-weight: 500; font-size: 1em;text-align: center; margin: 0" v-if="errMessage">{{ errMessage.message ? errMessage.message : errMessage }}
                        </p>
                        <p :style="isQueued ? 'color: #ff9800;' : 'color: red;'" style="font-weight: 500; font-size: 1em;text-align: center; margin: 0" v-if="errMessage2">{{ isQueued && errMessage?.errors ? Object.values(errMessage?.errors).flat()[0] : (errMessage.message || errMessage?.errors ? (errMessage?.message ? errMessage?.message + ' ' : '') + (errMessage?.errors ? Object.values(errMessage?.errors).flat()[0] : '') : errMessage) }}
                        </p>
                        <!-- <p style="color: orange; font-weight: 500; font-size: 1em; margin: 0" v-if="errMessage && saveContext">Draft has
                            been saved.</p> -->
                        <!-- <p v-if="errMessage">{{errMessage}}</p> -->
                        <!-- IF STOCK ITEMS AVAILABLE -->
                        <div v-if="stock_items" style="padding-left: 20px;">
                            <!-- IF SINGLE ITEM -->
                            <p style="font-size: 1em;margin-top: 2px;margin-bottom: 2px" v-if="stock_items.length == 1"><b>Dispensed drug:</b> {{stock_items[0]?.alias?.name }}</p>
                            <p style="font-size: 1em;margin-top: 2px;margin-bottom: 2px" v-if="stock_items.length == 1"><b>Retrieving:</b> {{payload?.quantity}} {{stock_items[0]?.alias?.form}}/s <span v-if="payload?.dose_unit && stock_items[0]?.alias?.form?.toLowerCase() != payload?.dose_unit?.toLowerCase()">({{ payload?.dose_quantity }} {{ payload?.dose_unit }}/s)</span></p>
                            <p style="font-size: 1em;margin-top: 2px;margin-bottom: 2px" v-if="stock_items.length == 1"><b>Remaining balance:</b> {{(stock_items[0]?.quantity - payload?.quantity).toFixed(2)}} {{stock_items[0]?.alias?.form}}/s</p>
                            
                            <!-- IF MULTIPLE ITEMS -->
                            <div v-else style="display: flex; flex-direction: column; align-items: baseline; gap: 10px;">
                                <p style="font-size: 1em; margin: 0;"><b>Confirm dispensed drug: </b></p>
                                <Dropdown v-model="selected_stock_item" :options="stock_items" optionLabel="name"
                                @change="replaceStockItemId()"
                                :placeholder="selected_stock_item ? selected_stock_item.name : 'Select drug'" />
                                <p style="font-size: 1em;margin-top: 2px;margin-bottom: 2px" v-if="selected_stock_item"><b>Dispensed drug:</b> {{ selected_stock_item?.alias?.name }}</p>
                                <p style="font-size: 1em;margin-top: 2px;margin-bottom: 2px" v-if="selected_stock_item"><b>Retrieving:</b> {{ payload?.quantity }} {{ selected_stock_item?.alias?.form }}/s <span v-if="payload?.dose_unit && selected_stock_item?.alias?.form?.toLowerCase() != payload?.dose_unit?.toLowerCase()">({{ payload?.dose_quantity }} {{ payload?.dose_unit }}/s)</span></p>
                                <p style="font-size: 1em;margin-top: 2px;margin-bottom: 2px" v-if="selected_stock_item"><b>Remaining balance:</b> {{ (selected_stock_item?.quantity - payload?.quantity).toFixed(2) }} {{ selected_stock_item?.alias?.form }}/s</p>
                                
                            </div>
                            <p style="margin-left: 20px; font-size: 1em;" v-if="discardAvailable">
                                Would you like to discard unused drug? ({{ discardAvailable }}) <input type="checkbox" style="height:1em; min-width: 5px;" class="discard-checkbox" v-model="discardRemaining" />
                            </p>
                        </div>
                        
                        <!-- SINGLE SIGNATURE STATUS -->
                        <p v-if="(dualForMeds || dual) && hasSingleSignaturePrimary" style="margin: 0; margin-left: 20px; color: #00AD50; text-align: center; font-weight: 500;">
                            You have the single signature primary permission and may sign this action alone. A witness is optional.
                        </p>
                        <p v-else-if="(dualForMeds || dual)" style="margin: 0; margin-left: 20px; color: #E04F39; text-align: center; font-weight: 500;">
                            This action requires two signatures (primary + witness).
                        </p>
                        <!-- SIGN WARNING  -->
                        <p style="margin: 0; margin-left: 20px; color:red; text-align: center">Please use PIN if set.</p>
                        <form class="action-modal" style="padding-top: 0">
                            
                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                            <div v-if="!noAuthRequired" class="form-section-container" style="grid-template-columns: 1fr; margin: 0 20px; width: calc(100% - 20px); padding-left: 0px;">
                                <!-- v-if="notes" -->
                                <div v-if="endpoint?.includes('administ')">
                                    <div v-if="!bulkAdminister">
                                        <!-- <Textarea v-tooltip="'Notes'" style="width: 100%; min-height: 10em;" v-if="!toSubmit.notes"
                                        placeholder="Typing any Notes here will be saved" :autoResize="true" v-model="verification.notes" /> -->
                                        <Textarea v-tooltip="'Notes'" style="width: 100%; min-height: 10em;"
                                            placeholder="Typing any Notes here will be saved" :autoResize="true" v-model="getNotes" />
                                    </div>
                                    <Textarea v-tooltip="'Notes'" style="width: 100%; min-height: 5em;" v-if="displayReason"
                                        placeholder="Enter a reason here." :autoResize="true" v-model="reason" />
                                </div>
                                <div v-if="drugReg && drugReg.length">
                                    <p style="text-align: left;">You are removing the following drugs from the register:
                                    </p>
                                    <table style="border-collapse: collapse">
                                        <tr v-for="(item, index) in drugReg" :key="index" class="drug-entry-transfer">
                                            <td style="width: 50%;">
                                                <p>{{ item.stock }}</p>
                                            </td>
                                            <td>
                                                <p>{{ item.qty }} {{ item.form }}/s</p>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div v-if="(manual_loop && payloads) || displaySaveContext">
                                    <div v-for="(value, key) in saveContext" :key="key" style="text-align: left; margin-top: -10px;" >
                                        <p v-if="key != 'doubleSig' && key != 'drugs' && key != 'supplemental' && key != 'patient'" style="font-size: 1em;"><span style="font-weight: bold">{{ key.slice(0,1).toUpperCase() }}{{ key.split('_').join(' ').slice(1) }}</span> - {{ value }}</p>
                                    </div>
                                </div>
                                <div style="text-align: left; background-color: #f3f4f4; padding: 0 10px;" v-if="manual_loop && payloads">
                                    <p style="font-size: 1em;">Medication being signed off ({{ payloadsIndex+1 }} of {{payloads.length}}):</p>
                                    <p style="font-size: 1em;" v-if="payloads[payloadsIndex].drugs">- {{payloads[payloadsIndex].drugs[0].alias}} x <b>{{ payloads[payloadsIndex].drugs[0].qty }} </b></p>
                                    <p style="font-size: 1em;" v-else>- {{payloads[payloadsIndex].stock_items[0].alias}} x <b>{{ payloads[payloadsIndex].stock_items[0].qty }} </b></p>
                                </div>
                                <div
                                    style="margin-top: 10px;display: grid; justify-content: space-around; margin: 0 auto;" 
                                        :style="
                                            ((this.forceSingleSig === undefined ? true : (this.forceSingleSig ? false : true)) && (($store.state.company.type == 'warehouse' && $store.state.user.role.permissions.includes('signature_primary') && $store.state.user.role.permissions.includes('signature_witness')) ? isStatus?.status && endpoint !== '/warehouse/destroy-orders' ? false : !signPrimarySignature : isStatus == false ? true : (isStatus == false || isStatus) ? false : ($store.state.user.role.permissions.includes('signature_primary') && $store.state.user.role.permissions.includes('signature_witness')) ? (this.dualForMeds || this.dual) :  false) && 
                                            ((this.dualForMeds || this.dual) ||
                                            endpoint =='/drug-safe-retrieval' ||
                                            endpoint =='/stock-take-submit')) ? {gridTemplateColumns: '1fr 1fr', gridGap: '10px', width: '100%'}:{}">
                                    <!-- && !singleSig -->
                                        <div style="display: grid; grid-gap: 10px;" v-if="(displayReason ? (reason ? true : false) : true) && !loading1 && !success1 && warehouseCounterSignCheck(1)">
                                        <h4 style="margin: 0; padding-left: 15px;text-align: left">Signature {{ (this.dualForMeds || this.dual) && !witness && ($store.state.user.role.permissions.includes('signature_primary') || $store.state.user.role.permissions.includes('signature_witness'))  && !signPrimarySignature && warehouseCounterSignCheck(2) === false ? '1' :
                                         ''
                                        }}
                                        </h4>
                                        <input
                                            v-on:keyup.enter="verifySig(1)"
                                            ref="sig1username"
                                            type="text"
                                            v-model="sig1.name"
                                            placeholder="Username..."
                                        >
                                        <input
                                            v-on:keyup.enter="verifySig(1)"
                                            ref="sig1password"
                                            type="password"
                                            v-model="sig1.password"
                                            :placeholder="success1 ? 'Signed' : 'PIN/Password...'"
                                            autocomplete="one-time-code"
                                        >
                                        <div class="green-button"
                                            @click="verifySig(1)">
                                            {{success1 ? 'Signed' : 'Sign'}}
                                        </div>
                                    </div>
                                    <div v-if="!success1 && loading1">
                                        <i class="pi pi-spin pi-spinner"
                                            style="font-size: 2rem !important;margin: 0 auto; margin-top: 2em;"></i>
                                    </div>
                                        <div v-if="success1 && warehouseCounterSignCheck(1)" style="display: flex; align-items: center;width: 100%;justify-content: center;height: 147px">
                                        <h4
                                            style="color: green; margin: 0; border: 2px solid green; padding: 5px 10px; border-radius: 5px">
                                            {{ prescriber ? "Prescriber" : "Signature 1" }} signed.</h4>
                                            <!-- <img :src="require('@/assets/icons/checkIcons.png')"
                                                alt="checkimage"
                                                class="scaled-image"
                                            /> -->
                                    </div>
                                    
                                    <div style="display: grid; grid-gap: 10px"
                                        v-if="(
                                            (this.forceSingleSig === undefined ? true : (this.forceSingleSig ? false : true)) && warehouseCounterSignCheck(2) === false &&
                                            (displayReason ? (reason ? true : false) : true) && 
                                            !success2 && !signPrimarySignature &&
                                            !loading2 && (
                                                    endpoint =='/drug-safe-retrieval' ||
                                                    endpoint =='/stock-take-submit' || (
                                                        (this.dualForMeds || this.dual) && 
                                                        ($store.state.user.role.permissions.includes('signature_primary') || $store.state.user.role.permissions.includes('signature_witness'))
                                                    )
                                                ))">
                                        <h4 style="margin: 0; padding-left: 15px;text-align: left">Signature 2 {{ optional == true ?
                                                '(optional)' : ''
                                        }}</h4> 
                                        <input
                                            v-on:keyup.enter="verifySig(2)"
                                            ref="sig2username"
                                            type="text"
                                            v-model="sig2.name"
                                            placeholder="Username..."
                                        >
                                        <input
                                            v-on:keyup.enter="verifySig(2)"
                                            ref="sig2password"
                                            type="password"
                                            v-model="sig2.password"
                                            :placeholder="success2 ? 'Signed' : 'PIN/Password...'"
                                            autocomplete="one-time-code"
                                        >
                                        <div class="green-button"
                                            @click="verifySig(2)">
                                            {{success2 ? 'Signed' : 'Sign'}}
                                        </div>
                                    </div>
                                    <div style="display: grid; grid-gap: 10px; margin-left: 3em; align-content: flex-start"
                                        v-if="(displayReason ? (reason ? true : false) : true) && witness">
                                        <h4 style="margin: 0; padding-left: 10px;">Witness</h4>
                                        <input ref="witnessname" type="text" v-model="witnessName" placeholder="Witness Name">
                                        <input ref="witnessrole" type="text" v-model="witnessRole" placeholder="Witness Role">
                                        <input ref="witnessref" type="text" v-model="witnessRefNumber" placeholder="Witness Ref Number">
                                    </div>
                                    <div v-if="!success2 && loading2">
                                        <i class="pi pi-spin pi-spinner"
                                            style="font-size: 2rem !important;margin-top: 2em;"></i>
                                    </div>
                                    <div v-if="success2"
                                        style="margin-left: 3em; display: flex; align-items: center; margin-top: 2em;">
                                        <h4
                                            style="color: green;margin: 0; border: 2px solid green; padding: 5px 10px; border-radius: 5px">
                                            Signature 2 signed.</h4>
                                    </div>


                                </div>
                            </div>
                            <div v-else class="form-section-container" style="grid-template-columns: 1fr; margin: 0 20px;">
                                <p style="font-size: 1em; margin: 0;" v-if="!errMessage">Click complete to submit.</p>
                            </div>
                        </form>
                    </slot>
                </div>
                
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px; padding-top: 0px" v-if="witness || noAuthRequired || ((!(this.dualForMeds || this.dual) || $store.state.user.role.permissions.includes('single_signature_primary')) && success1) || ((optional || success2) && success1)">
                    <slot v-if="!witness" name="footer" style="display: flex;"> 
                 <!-- || singleSig -->
                         <div v-if="noAuthRequired || ((!(this.dualForMeds || this.dual) || $store.state.user.role.permissions.includes('single_signature_primary')) && success1) || ((optional || success2) && success1)"
                            style="margin: 0 auto; text-align: center;display: flex; align-items: center; margin-bottom: 2em; margin-top: 2em; cursor: pointer"
                            @click=" noAuthRequired ? noAuthSignature() : submitAction()">
                            <h3 style="margin: 0; border-bottom: 2px solid black; width: fit-content;">{{errMessage ? 'Retry' : 'Complete'}}</h3>
                        </div>
                    </slot>
                    <slot v-else name="footer" style="display: flex;">
                        <div v-if="success1 && witnessRole && witnessName"
                            style="margin: 0 auto; text-align: center;display: flex; align-items: center; margin-bottom: 2em; margin-top: 2em; cursor: pointer"
                            @click="submitAction">
                            <h3 style="margin: 0; border-bottom: 2px solid black; width: fit-content;">{{errMessage ? 'Retry' : 'Complete'}}</h3>
                        </div>
                    </slot>
                </div>
            </div>
            
            <div v-else-if="submitLoading"  class="modal-container" style="min-width: 500px; width: 500px; margin: 0 auto; display: grid;">
                <p style="font-size: 1em;font-weight: 500; text-align: center">Submitting request...</p>
                <p v-if="sequential_loop && sequentialTotal > 1" style="font-size: 1em; text-align: center; margin: 0">
                    Recording medication {{ sequentialCompleted + 1 > sequentialTotal ? sequentialTotal : sequentialCompleted + 1 }} of {{ sequentialTotal }}
                </p>
                <i class="pi pi-spin pi-spinner"
                    style="font-size: 2rem !important;padding-top: 1em; padding-bottom: 1em; color: green; margin: 0 auto"></i>
            </div>
            <div v-else-if="submitSuccess" class="modal-container" style="min-width: 500px; width: 500px; margin: 0 auto; display: grid;">
                <div style="display: flex; align-items: center; width: 100%; justify-content: center; min-height: 147px; flex-direction: column;">
                    <h4 :style="isQueued ? 'color: #ff9800; border: 2px solid #ff9800;' : 'color: #00AD50; border: 2px solid #00AD50;'" style="margin: 0; padding: 5px 10px; border-radius: 5px; font-size: 1.2em; text-align: center;">
                        {{ (endpoint === '/prescription/sign' || endpoint.includes('prescription')) ? (isQueued ? 'Queued for Store and Forward' : (payload && payload.no_erx ? 'Prescription Successfully Signed' : (payload && payload.is_paper ? 'Paper Prescription Successfully Signed' : 'ePrescription Successfully sent to NPDS'))) : 'Successfully Signed' }}
                    </h4>
                    <p style="margin: 0; margin-top: 10px; color:red; text-align: center" v-if="isQueued">Please use PIN if set.</p>
                    <div v-if="itemResults.length > 1" style="margin-top: 1em; text-align: left; width: 90%;">
                        <p v-for="result in itemResults" :key="result.index" style="margin: 0; font-size: 1em;">
                            <span style="color: #00AD50; font-weight: 500;">&#10003;</span> {{ result.label }}<span v-if="result.queued"> - queued for store and forward</span>
                        </p>
                    </div>
                    <div v-if="errMessage && itemResults.length" style="color: #ff9800; margin-top: 1em; text-align: center; max-width: 90%;">
                        <p style="margin: 0;">{{ errMessage }}</p>
                    </div>
                    <div v-if="queuedErrors && queuedErrors.length > 0" style="color: #ff9800; margin-top: 1em; text-align: center; max-width: 90%;">
                        <p v-for="(error, index) in queuedErrors" :key="index" style="margin: 0;">{{ error }}</p>
                    </div>
                    <button class="blue-button" style="margin-top: 1.5em; width: 100px;" @click="handleSuccessClose()">Close</button>
                </div>
            </div>
            <div v-else-if="sequentialHasFailures" class="modal-container" style="min-width: 500px; width: 500px; margin: 0 auto; display: grid;">
                <div style="display: flex; align-items: flex-start; width: 100%; min-height: 147px; flex-direction: column; padding: 0 20px;">
                    <h4 style="margin: 0; padding: 5px 10px; border-radius: 5px; font-size: 1.2em; color: #E04F39; border: 2px solid #E04F39;">
                        {{ sequentialCompleted }} of {{ sequentialTotal }} recorded
                    </h4>
                    <p style="font-size: 1em; margin-top: 1em; text-align: left;">The medications below were not recorded. Retry sends only those - the signatures already given still apply.</p>
                    <div style="width: 100%; text-align: left;">
                        <div v-for="result in itemResults" :key="result.index" style="margin-bottom: 8px;">
                            <p style="margin: 0; font-size: 1em;">
                                <span v-if="result.ok" style="color: #00AD50; font-weight: 500;">&#10003;</span>
                                <span v-else style="color: #E04F39; font-weight: 500;">&#10007;</span>
                                {{ result.label }}
                            </p>
                            <p v-if="!result.ok" style="margin: 0; padding-left: 18px; color: #E04F39; font-size: 0.9em;">{{ result.error }}</p>
                            <p v-if="!result.ok && result.stage === 'follow_up'" style="margin: 0; padding-left: 18px; color: #ff9800; font-size: 0.9em;">
                                Removed from the register. The administration was not recorded - a retry sends only the administration.
                            </p>
                        </div>
                    </div>
                    <div style="display: flex; margin: 1.5em auto 0 auto;">
                        <button class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeAfterPartial()">Close</button>
                        <button class="blue-button" style="width: 100px;" @click="retrySequentialFailures()">Retry</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {toRaw} from 'vue'
import { drugsRequireDoubleSig } from '../../services/doubleSignature';

export default {
    props: ['single', 'loop', 'close', 'endpoint', 'endpoint2', 'isSuccessful', 'payload', 'payload2', 'header', 'manual_loop', 'stock_items', 'discardAvailable',
        'dual', 'warning', 'prescriber', 'notes', 'witness', 'optional', 'drugReg', 'saveContext', 'displaySaveContext', 'noAuthRequired', 'bulkAdminister', 'displayReason','isStatus', 'forceSingleSig', 'isWarehouse',
        // Optional override for the Signature record's `type` (e.g. 'cancellation'). Defaults to the
        // normal '' (primary) type used everywhere else when not supplied by the caller.
        'signatureType',
        // One signature pair covering several items, posted one at a time. Separate from `loop`, which
        // fires every item at once and emits a success per item - six other workflows depend on that
        // behaviour, so this is its own branch rather than a change to theirs.
        'sequential_loop',
        // Display name per payload row, in the same order, for the progress line and the summary.
        'item_labels',
        // Optional second request per row, sent once the first one succeeds:
        //   { endpoint, payloads: [...], response_key }
        // `payloads` runs parallel to `payload`, and `response_key` names the field the first response is
        // written into - how an administration is told which retrieval it belongs to. A row that clears
        // the first stage and fails the second keeps its first response, so a retry resumes at the second
        // stage instead of repeating a movement that already happened.
        'sequential_follow_up'],
    components: {
    },
    computed: {
        getNotes() {
            if (this.payload.notes) return this.payload.notes;
            return this.verification.notes;
        },
        dualForMeds() {
            if (this.payload?.length >= 1) return this.payload.some(item => item.has_scheduled_items)
            if (this.payload.has_scheduled_items) return this.payload.has_scheduled_items;
            // payload can be drugs (everything), or stock_items (adjustmentmodal), or, ?? (newstocktake)
            let payloadDrugs = null
            if (this.payload.drugs != null) {
                payloadDrugs = toRaw(this.payload.drugs)
            }
            else if (this.payload.stocktake != null) {
                payloadDrugs = toRaw(this.payload.stocktake)
            }
            else if (this.payload.stock_items != null) {
                payloadDrugs = toRaw(this.payload.stock_items)
            }

            const facility = toRaw(this.$store.getters.getCurrentLocation)?.facility
            return drugsRequireDoubleSig(payloadDrugs, facility)
        },
        hasSingleSignaturePrimary() {
            return this.$store.state.user.role.permissions.includes('single_signature_primary');
        },
        // sequential_loop only. A part-recorded set shows the summary rather than dropping back to the
        // signature form, which is what the other branches do on failure.
        sequentialHasFailures() {
            return this.itemResults.some(result => !result.ok);
        },
        sequentialTotal() {
            return (this.sequential_loop && this.payload && this.payload.length) ? this.payload.length : 0;
        }
    },
    data() {
        return {
            selected_stock_item: null,
            submitLoading: false,
            submitSuccess: false,
            successArgs: [],
            successTimeoutId: null,
            signError: 'You cannot use the same sign-in for both signatures.',
            errMessage: '',
            errMessage2: '',
            witnessName: '',
            witnessRole: '',
            witnessRefNumber: '',
            toSubmit: this.payload,
            toSubmit2: this.payload2,
            verification: {
                notes: '',
            },
            discardRemaining: false,
            singleSig: false,
            sigToken1: '',
            signature_1: '',
            sigToken2: '',
            signature_2: '',
            loading1: false,
            loading2: false,
            sig1: {
                name: '',
                password: '',
                company_id: this.$store.state.company.uuid,
            },
            success1: false,
            sig2: {
                name: '',
                password: '',
                company_id: this.$store.state.company.uuid,
            },
            success2: false,
            payloads:null,
            payloadsIndex: 0,
            reason:'',
            signPrimarySignature: false,
            cachedResults: {},
            isQueued: false,
            queuedErrors: [],
            // sequential_loop only. Kept local to that branch so the existing `loop` path is untouched.
            sequentialCompleted: 0,
            // One entry per item: { label, ok, response|error }. Drives the progress line, the summary
            // and which rows a retry re-posts.
            itemResults: []
        }
    },
    methods: {
        triggerSuccess(...args) {
            this.submitLoading = false;
            this.submitSuccess = true;
            this.successArgs = args;
            
            this.successTimeoutId = setTimeout(() => {
                this.handleSuccessClose();
            }, 5000);
        },
        handleSuccessClose() {
            if (this.successTimeoutId) {
                clearTimeout(this.successTimeoutId);
                this.successTimeoutId = null;
            }
            if(this.endpoint2 == '/administer-expired-chart-note'){
                this.$emit('isSuccessful', true);
            } else {
                this.$emit('isSuccessful', ...this.successArgs);
            }
            this.closeModal();
        },
        noAuthSignature(){
            axios.post('/account-signature', {}, this.$store.state.header).then(res=>{
                console.log('this is the account sig res', res.data);
                this.signature_1 = res.data.uuid;
                this.success1 = true;
                this.submitAction();
            }).catch(err=>{
                console.log('this is the error for account sig request', err.response.data);
            })
        },
        closeModal() {
            console.log('hitting this closemodal function signaturemodal')
            this.$emit('close', true);
        },
        labelForIndex(index) {
            return (this.item_labels && this.item_labels[index]) ? this.item_labels[index] : `Item ${index + 1}`;
        },
        readError(err) {
            const data = err && err.response ? err.response.data : null;
            if (!data) return 'Request failed. Please try again.';
            if (typeof data === 'string') return data;
            // Falls back rather than returning an empty string: a body with neither key left the
            // failed row showing a red cross and no reason under it.
            return ((data.message || '') + ' ' + (data.errors ? Object.values(data.errors).flat()[0] : '')).trim()
                || 'Request failed. Please try again.';
        },
        setItemResult(index, result) {
            const existing = this.itemResults.findIndex(entry => entry.index === index);
            const entry = { index, ...result };
            if (existing > -1) {
                this.itemResults.splice(existing, 1, entry);
            } else {
                this.itemResults.push(entry);
            }
        },
        /**
         * One signature pair, several items, posted one at a time.
         *
         * Sequential rather than concurrent: each item creates a unit and moves the balance on the same
         * register, so overlapping posts can race each other. A rejection on one item does not stop the
         * rest - every register line stands on its own - and the signatures are left in place afterwards,
         * because they are looked up by uuid rather than consumed, so a retry reuses them instead of
         * making the nurse sign the whole set again.
         *
         * @param  {Array}  indices  positions in `payload` to post. A retry passes only the failures.
         */
        async runSequentialLoop(indices) {
            this.submitLoading = true;
            this.errMessage = '';
            this.errMessage2 = '';

            // The note typed on the signature screen belongs on every line, appended to whatever the row
            // already carries. Removed from `verification` first so it is not sent twice.
            const sharedNote = this.verification.notes;
            delete this.verification.notes;

            for (const index of indices) {
                const item = this.payload[index];
                item.verification = this.verification;

                if (sharedNote) {
                    item.notes = `${item.notes ? item.notes + ' \n' : ''}${sharedNote}`;
                }
                // Same defaulting as the single-post path - a retrieval with nothing discarded still has
                // to say so.
                if (((this.drugReg && this.drugReg.length) || this.endpoint == '/drug-safe-retrieval') && !this.discardRemaining && !item.discard_amount) {
                    item.discard_amount = '0';
                }

                // Set on a first stage that already went through, so a retry cannot repeat it.
                const prior = this.itemResults.find(entry => entry.index === index);
                let firstResponse = (prior && prior.firstResponse !== undefined) ? prior.firstResponse : undefined;
                let queued = !!(prior && prior.queued);
                let stage = 'first';

                try {
                    if (firstResponse === undefined) {
                        const res = await axios.post(this.endpoint, item, this.header ? this.header : this.$store.state.header);
                        this.$store.dispatch('getRefreshToken');
                        this.$emit('responseData', res.data);

                        firstResponse = res.data;
                        queued = !!(res && res.data && res.data.queued === true);
                        if (queued) {
                            this.isQueued = true;
                            if (res.data.errors && Array.isArray(res.data.errors)) {
                                this.queuedErrors = this.queuedErrors.concat(res.data.errors);
                            }
                        }
                    }

                    let followUpResponse;
                    // A queued first stage has not been recorded yet, so there is no uuid for the second
                    // request to reference - it would only fail validation. The row is reported as queued
                    // and the second stage is left undone.
                    if (this.sequential_follow_up && this.sequential_follow_up.endpoint && !queued) {
                        stage = 'follow_up';
                        const followUp = {
                            ...((this.sequential_follow_up.payloads && this.sequential_follow_up.payloads[index]) || {}),
                            verification: this.verification
                        };
                        if (this.sequential_follow_up.response_key) {
                            followUp[this.sequential_follow_up.response_key] = firstResponse;
                        }
                        const followUpRes = await axios.post(this.sequential_follow_up.endpoint, followUp, this.header ? this.header : this.$store.state.header);
                        followUpResponse = followUpRes.data;
                    }

                    this.sequentialCompleted += 1;
                    this.setItemResult(index, {
                        label: this.labelForIndex(index),
                        ok: true,
                        queued,
                        firstResponse,
                        response: followUpResponse !== undefined ? followUpResponse : firstResponse
                    });
                } catch (err) {
                    this.setItemResult(index, {
                        label: this.labelForIndex(index),
                        ok: false,
                        queued,
                        stage,
                        firstResponse,
                        error: this.readError(err)
                    });
                    this.$emit('error', err && err.response ? err.response.data : null);
                }
            }

            const failed = this.itemResults.filter(result => !result.ok);

            if (failed.length) {
                // Nothing follows a part-recorded set. The discard below covers the whole submission, so
                // it waits until every line is in.
                this.submitLoading = false;
                return;
            }

            if (this.payload2 && this.endpoint2) {
                this.toSubmit2 = { ...this.payload2, verification: this.verification };
                try {
                    await axios.post(this.endpoint2, this.toSubmit2, this.header ? this.header : this.$store.state.header);
                } catch (err) {
                    // The administrations are recorded and cannot be unwound here, so the discard failing
                    // is reported against the set rather than turning it into a failure.
                    this.errMessage = `The medications were recorded. The discard was not: ${this.readError(err)}`;
                }
            }

            this.triggerSuccess(this.itemResults.map(result => result.response));
        },
        // Closing a part-recorded set. The rows that were recorded are named so the caller can drop them -
        // leaving them on screen lets the same medication be submitted a second time.
        closeAfterPartial() {
            this.$emit('partialComplete', {
                recorded: this.itemResults.filter(result => result.ok).map(result => result.index),
                failed: this.itemResults.filter(result => !result.ok).map(result => result.index),
                // Failed, but the first stage went through. The stock has moved, so these rows cannot be
                // submitted again either - the caller has to say what happened to them.
                firstStageOnly: this.itemResults
                    .filter(result => !result.ok && result.firstResponse !== undefined)
                    .map(result => result.index)
            });
            this.closeModal();
        },
        retrySequentialFailures() {
            const failedIndices = this.itemResults.filter(result => !result.ok).map(result => result.index);
            if (!failedIndices.length) return;
            this.runSequentialLoop(failedIndices);
        },
        submitAction() {
            this.submitLoading = true;
            if ( (this.$store.state.user.role.permissions.includes('signature_primary') || this.$store.state.user.role.permissions.includes('signature_witness') == false ||  this.$store.state.user.role.permissions.includes('single_signature_primary')) && this.signature_1?.length > 0){
                    this.verification.signature_1 = this.signature_1;
            }
            if ( (this.dualForMeds || this.dual)  && (this.$store.state.user.role.permissions.includes('signature_primary') || this.$store.state.user.role.permissions.includes('signature_witness')) && this.signature_2?.length > 0) {
                console.log('this is a dual sig');
                if (this.optional) {
                    if (this.signature_2) {
                        this.verification.signature_2 = this.signature_2;
                        console.log('this is an optional sig2 signature signed');
                    }
                    console.log('this is an optional sig');
                } else {
                    this.verification.signature_2 = this.signature_2;
                    console.log('this is a dual sig that is not optional');
                }
                console.log('running through dual conditional', this.verification)
            }
            // ONE SIGNATURE PAIR ACROSS SEVERAL ITEMS, POSTED ONE AT A TIME
            if (this.sequential_loop) {
                this.sequentialCompleted = 0;
                this.itemResults = [];
                this.runSequentialLoop(this.payload.map((_, index) => index));
            }
            // FOR REQUESTS LIKE LOOPING THROUGH MULTIPLE S8 MEDS TO REMOVE FROM REGISTER
            else if (this.loop) {

                console.log('LOOPING THROUGH THE PAYLOAD DATA', this.loop, this.payload, typeof this.payload);
                let notes = this.verification.notes;
                delete this.verification.notes;
                var allResponse = []
                this.payload.forEach((item, index) => {
                    setTimeout(()=>{
                        console.log('this is a note', notes);
                        // Assigns verification signatures to items based on their type (primary, witness, or scheduled_items) 
                        // if the process is for a warehouse and the multiple data selected. Each item receives relevant signatures
                        item.verification = this.verification;
                        if (this.isWarehouse && this.isStatus.isbulk) {
                            if (item?.type == "primary") {
                                item.verification = {};
                                if (this.signature_2) {
                                    item.verification.signature_2 = this.signature_2
                                }
                            }
                            if (item?.type == "witness") {
                                item.verification = {};
                                if (this.signature_1) {
                                    item.verification.signature_1 = this.signature_1
                                }
                            }
                            if (item?.type == "scheduled_items") {
                                item.verification = {};
                                if (this.signature_1) {
                                    item.verification.signature_1 = this.signature_1
                                }
                                if (this.signature_2) {
                                    item.verification.signature_2 = this.signature_2
                                }
                            }
                        }
                        this.bulkItemsCompleted = 0;
                        axios.post(this.endpoint, item, this.$store.state.header).then(res => {
                            this.bulkItemsCompleted+=1;

                            console.log('looping through items', res);
                            this.$store.dispatch('getRefreshToken');
                            this.$emit('responseData', res.data);
                            if (res && res.data && res.data.queued === true) {
                                this.isQueued = true;
                                this.errMessage = 'Queued for Store and Forward';
                                if (res.data.errors && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
                                    this.queuedErrors = res.data.errors;
                                }
                                
                                this.submitLoading = false;
                                this.sig1 = {
                                    name: '',
                                    password: '',
                                    company_id: this.$store.state.company.uuid,
                                };
                                this.sig2 = {
                                    name: '',
                                    password: '',
                                    company_id: this.$store.state.company.uuid,
                                };
                                this.loading1 = false;
                                this.success1 = false;
                                this.success2 = false;
                                return;
                            }
                            setTimeout(() => {
                                if(this.endpoint == '/drug-safe-retrieval'){
                                    this.$emit('drugSafeRetrievalId', res.data);
                                } else{
                                    console.log('THIS IS THE SETTIMEOUT issuccessful', res.data, index);
                                    // Collects responses from multiple API calls into the `allResponse` array if processing is for a warehouse and send
                                    if (this.isWarehouse && this.isStatus.isbulk) {
                                        allResponse.push(res.data)
                                        if (index == (this.payload.length - 1)) {
                                            this.triggerSuccess(allResponse, ...this.toSubmit);
                                        }
                                    } else {
                                        this.triggerSuccess(this.endpoint == '/administer' ?  {data: item.calendar_item_id, response: res.data, index: index} : res.data);
                                    }
                                }
                                if(index == (this.payload.length -1)){
                                    console.log('hitting the close modal from the signature modal', index, this.payload.length);
                                }
                            }, index * 200);
                            this.errMessage = '';

                        }).catch(err => {
                            console.log('this is the error 290', err, err.response, err.response.data, err.response.data.errors);
                            if (err.response.data && err.response.data.queued === true) {
                                this.isQueued = true;
                                this.errMessage = err.response.data;
                            } else {
                                this.errMessage = (err.response.data.message || '') + ' ' + (err.response.data.errors ? Object.values(err.response.data.errors).flat()[0] : '');
                            }
                            this.submitLoading = false;
                            this.sig1 = {
                                name: '',
                                password: '',
                                company_id: this.$store.state.company.uuid,
                            };
                            this.sig2 = {
                                name: '',
                                password: '',
                                company_id: this.$store.state.company.uuid,
                            };
                            this.loading1 = false;
                            this.success1 = false;
                            this.success2 = false;

                            this.singleSig = false;
                            return ;
                        });
                    },100)
                   
                })
            } else if(this.manual_loop){
                console.log('this is a manual loop process', this.payload);
                this.toSubmit = {...this.payloads[this.payloadsIndex]};
                console.log('hitting at 375');
                if (!this.verification.notes) {
                    delete this.verification.notes;
                } else {
                    delete this.verification.notes;
                }
                

                this.toSubmit.verification = this.verification;
                if (this.toSubmit2) {
                    this.toSubmit2.verification = this.verification;
                }
                if(this.selected_stock_item){
                    this.toSubmit.stock_item_id = this.selected_stock_item.uuid;
                }
                // if(this.witness){
                //     this.toSubmit.witness_role = this.witnessRole;
                //     this.toSubmit.witness_name = this.witnessName;
                // }
                // this.$store.dispatch('getRefreshToken');
                this.toSubmit.notes = this.toSubmit.notes+` \n Reason: ${this.reason}`;

                if(((this.drugReg && this.drugReg.length) || this.endpoint == '/drug-safe-retrieval') && !this.discardRemaining){ 
                    this.toSubmit.discard_amount = '0';
                }
                console.log('this is the toSubmit', this.toSubmit);
                axios.post(`${this.drugReg && this.drugReg.length ? '/drug-safe-retrieval' : this.endpoint}`, this.toSubmit, this.header ? this.header : this.$store.state.header).then(res => {
                    
                    console.log('action has been submitted', res);
                    this.$store.dispatch('getRefreshToken');
                    this.$emit('responseData', res.data);
                    if (res && res.data && res.data.queued === true) {
                        this.isQueued = true;
                        
                        this.errMessage = 'Queued for Store and Forward';
                        if (res.data.errors && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
                            this.queuedErrors = res.data.errors;
                        }
                        
                        this.submitLoading = false;
                        this.sig1 = {
                            name: this.sig1.name ? this.sig1.name : '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.sig2 = {
                            name:  this.sig2.name ? this.sig2.name : '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.loading1 = false;
                        this.success1 = false;
                        this.success2 = false;
                        return;
                    }
                    

                    this.submitLoading = false;
                    this.sig1 = {
                        name: this.sig1.name ? this.sig1.name : '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.sig2 = {
                        name:  this.sig2.name ? this.sig2.name : '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.loading1 = false;
                    this.success1 = false;
                    this.success2 = false;


                    setTimeout(() => {
                        
                        if(this.payloadsIndex+1 == this.payloads.length){
                            this.triggerSuccess(this.endpoint == '/administer' ?  {data: this.toSubmit.calendar_item_id, response: res.data, index: null} : res.data);
                            console.log('hitting the close modal on 494');
                        } else{
                            this.payloadsIndex +=1
                        }
                        
                    }, 200);
                    this.errMessage = '';

                }).catch(err => {
                    console.log('this is the error updated 389', err.response.data.message, err.response.data.errors);
                    // this.errMessage = err.response.data.errors;
                    // this.errMessage.concat('\n '+err.response.data.errors)
                    
                    if(err.response.data && err.response.data.queued === true){
                        this.isQueued = true;
                        this.errMessage = err.response.data;
                        this.errMessage2 = err.response.data.errors;
                        this.$emit('error', err.response.data);
                    } else if(err.response.data && err.response.data.message && err.response.data.message.includes('ePrescribing service could not be contacted')){
                        this.errMessage = 'Unfortunately the prescription has not been submitted as the request has timed out. Feel free to try again or issue a paper prescription.';
                        this.errMessage2 = err.response.data.errors ? err.response.data.errors : ''
                    } else{
                        this.errMessage = err.response.data;
                        this.errMessage2 = err.response.data.errors;
                        this.$emit('error', err.response.data);
                    }
                    
                    this.submitLoading = false;
                    this.sig1 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.sig2 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.loading1 = false;
                    this.success1 = false;
                    this.success2 = false;

                    this.singleSig = false;
                });
            }  else {
                this.toSubmit = {...this.payload};
                console.log('hitting at 465');
                if (!this.verification.notes) {
                    delete this.verification.notes;
                } else {
                    this.toSubmit.notes = this.verification.notes;
                    delete this.verification.notes;
                }
                if (this.signature_1 &&  this.signature_1.length > 0) {
                    this.verification.signature_1 = this.signature_1
                }
                if (this.signature_2 &&  this.signature_2.length > 0) {
                    this.verification.signature_2 = this.signature_2
                }
                console.log('this is the toSubmit', this.toSubmit);

                if (this.endpoint2 !== '/warehouse/sign-off-invoices' && this.endpoint2 !== '/warehouse/sign-off-orders'){
                    this.toSubmit.verification = this.verification;
                }
                if (this.toSubmit2) {
                    this.toSubmit2.verification = this.verification;
                }
                if(this.selected_stock_item){
                    this.toSubmit.stock_item_id = this.selected_stock_item.uuid;
                }
                // if(this.witness){
                //     this.toSubmit.witness_role = this.witnessRole;
                //     this.toSubmit.witness_name = this.witnessName;
                // }
                // this.$store.dispatch('getRefreshToken');
                if (this.toSubmit.notes) {
                    this.toSubmit.notes = this.toSubmit.notes+`${this.reason && !this.endpoint.includes('effectiveness') ? ' \n Reason:'+this.reason : ''}`;
                }
                console.log('this is the toSubmit post concat', this.toSubmit.notes);

                if(((this.drugReg && this.drugReg.length) || this.endpoint == '/drug-safe-retrieval') && !this.discardRemaining){ 
                    this.toSubmit.discard_amount = '0';
                }
                
                axios.post(`${this.drugReg && this.drugReg.length ? '/drug-safe-retrieval' : this.endpoint}`, this.toSubmit, this.header ? this.header : this.$store.state.header).then(async res => {
                    let endpoint2Response = null;  
                    if (this.endpoint2) {
                        if (this.endpoint2 == '/warehouse/sign-off-invoices' || this.endpoint2 == '/warehouse/sign-off-orders') {
                            // this is the payload for a direct sign off on created invoice/order
                            this.toSubmit2.invoice_id = [ res?.data?.invoice_id ],
                            this.toSubmit2.location_id = this.toSubmit.location_uuid ||  this.payload2.location_id
                            this.toSubmit2.notes = this.toSubmit.notes;
                        } else {
                            this.toSubmit2.notes = this.toSubmit2.notes + `\nReference: ${this.endpoint == '/stock-take-submit' ? res.data.stocktake_items[0].uuid : res.data}`;
                        }
                        
                           await axios.post(`${this.endpoint2}`, this.toSubmit2, this.$store.state.header).then(res1 => {
                                console.log('the second endpoint has been submitted', res1);
                                endpoint2Response = res1.data;
                                if (this.$route.name == 'Drug Register') {
                                    console.log('loading the drug register stuff');
                                    this.$store.dispatch('getDrugRegister', {
                                        sort_direction: 'desc',
                                        col: 'created_at',
                                        page: 1,
                                        filters: {
                                            transaction_id: '',
                                            to_from: '',
                                            entered_by: '',
                                            date: {
                                                start: '',
                                                end: ''
                                            },
                                            drug: '',
                                            imprest_only: false
                                        }
                                    });
                                } else if (this.$route.name == 'Invoices') {
                                    this.$store.dispatch('getPurchaseInvoices', {
                                        sort_direction: 'desc',
                                        col: 'created_at',
                                        facility_id: this.$store.state.currentLocation.uuid,
                                        page: 1,
                                        filters: {
                                            status: [],
                                            party: '',
                                            drug: '',
                                            date: {
                                                start: '',
                                                end: ''
                                            },
                                            invoice_number: '',
                                            show_active: true,
                                        },

                                    })
                                } else if (this.$route.name == 'Orders') {
                                    this.$store.dispatch('getOrders', {
                                        sort_direction: 'desc',
                                        facility_id: this.$store.state.currentLocation.uuid,
                                        col: 'created_at',
                                        page: 1,
                                        filters: {
                                            status: [],
                                            party: '',
                                            drug: '',
                                            date: {
                                                start: '',
                                                end: ''
                                            },
                                            invoice_number: '',
                                            show_active: true,
                                        },

                                    });
                                }
                            }).catch(err => {
                                console.log('this is the error updated', err, err.response, err.response.data, err.response.data.errors);
                                this.errMessage = err.response.data.errors
                                this.submitLoading = false;
                                this.sig1 = {
                                    name: '',
                                    password: '',
                                    company_id: this.$store.state.company.uuid,
                                };
                                this.sig2 = {
                                    name: '',
                                    password: '',
                                    company_id: this.$store.state.company.uuid,
                                };
                                this.loading1 = false;
                                this.success1 = false;
                                this.success2 = false;

                                this.singleSig = false;
                            });
                        
                    }
                    console.log('action has been submitted', res);
                    this.$store.dispatch('getRefreshToken');
                    this.$emit('responseData', res.data);
                    if (res && res.data && res.data.queued === true) {
                        this.isQueued = true;
                        this.errMessage = 'Queued for Store and Forward';
                        if (res.data.errors && Array.isArray(res.data.errors) && res.data.errors.length > 0) {
                            this.queuedErrors = res.data.errors;
                        }
                        
                        this.submitLoading = false;
                        this.sig1 = {
                            name: '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.sig2 = {
                            name: '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.loading1 = false;
                        this.success1 = false;
                        this.success2 = false;
                        return;
                    }

                    setTimeout(() => {
                        
                        if(this.endpoint == '/drug-safe-retrieval'){
                            this.$emit('drugSafeRetrievalId', res.data);
                        } else{
                            if(this.bulkAdminister){
                                console.log('bulk administer in signature modal path', this.toSubmit);
                                /**
                                 * Add response data to submitted item so it
                                 * can be accessed by SelectedPatientAdministration's submitIsCompleted method for
                                 * redo logic
                                 */
                                this.toSubmit.bulk_meds.forEach((item, index) => {
                                    item.response = res.data[index];
                                });
                                this.triggerSuccess(this.toSubmit);
                            } else{
                                this.triggerSuccess(this.endpoint == '/administer' ?  {data: this.toSubmit.calendar_item_id, response: res.data, index: null} : (this.endpoint2 == '/warehouse/sign-off-invoices' || this.endpoint2 == '/warehouse/sign-off-orders') ? endpoint2Response : res.data, this.toSubmit);
                            }
                            
                        }
                        console.log('hitting the closemodal at 642');
                        
                    }, 200);
                    this.errMessage = '';

                }).catch(err => {
                    console.log('this is the error updated 389', err.response?.data?.message, err.response?.data?.errors);
                    // this.errMessage = err.response.data.errors;
                    // this.errMessage.concat('\n '+err.response.data.errors)
                    
                    if(err.response.data && err.response.data.queued === true){
                        this.isQueued = true;
                        this.errMessage = err.response.data;
                        this.errMessage2 = err.response.data.errors;
                        this.$emit('error', err.response.data);
                    } else if(err.response.data && err.response.data.message && err.response.data.message.includes('ePrescribing service could not be contacted')){
                        this.errMessage = 'Unfortunately the prescription has not been submitted as the request has timed out. Feel free to try again or issue a paper prescription.';
                        this.errMessage2 = err.response.data.errors ? err.response.data.errors : ''
                    } else{
                        this.errMessage = err.response.data;
                        this.errMessage2 = err.response.data.errors;
                        this.$emit('error', err.response.data);
                    }
                    
                    this.submitLoading = false;
                    this.sig1 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.sig2 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.loading1 = false;
                    this.success1 = false;
                    this.success2 = false;

                    this.singleSig = false;
                });
            }
        },
        replaceStockItemId(){
            
        },
        verifySig(signatureEntry) {
            if (signatureEntry == 1 && (this.$store.state.company.type == 'warehouse' ? !this.verifyBulkOrSignleForWarehouse() : this.sig2.name != this.sig1.name) && !this.singleSig) {
                this.loading1 = true;
                axios.post('/sign', this.sig1, this.$store.state.header).then(res => {
                    console.log('this is the signature token', res.data);
                    this.$store.dispatch('getRefreshToken');
                    this.sigToken1 = res.data.access_token;
                    return res;
                }).then(() => {
                    axios.post('/signature', { signature_token: this.sigToken1, type: this.signatureType || '' }, this.$store.state.header).then(res => {
                        console.log('this is the signature id', res.data);
                        this.$store.dispatch('getRefreshToken');
                        this.signature_1 = res.data.uuid;
                        this.success1 = true;
                        this.loading1 = false;
                        if (this.$store.state.company.type == 'warehouse' && this.isStatus?.status ? this.isStatus?.status : (this.isStatus?.status == undefined && (!this.dualForMeds && !this.dual)) ? true : this.signPrimarySignature) {
                            this.submitAction()
                        }else{
                            if((this.dualForMeds || this.dual)){
                                if(this.success2 && this.success1){
                                    this.submitAction()
                                }
                            } else{
                                    if(this.success1){
                                        this.submitAction()
                                }
                            }
                        }

                        // if(res1.data.single_signature_primary && !this.drugReg && this.endpoint != "/stock-take-submit" && this.endpoint != "/new-delivery" && (!this.payload.pending)){
                        //     console.log('this is a single sig primary')
                        //     this.singleSig = true;
                        // }
                    }).catch((err) => {
                        this.errMessage = err.response.data;
                        this.errMessage2 = '';
                        this.submitLoading = false;
                        this.sig1 = {
                            name: '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.loading1 = false;
                        this.success1 = false;
                        this.success2 = false;
                        this.singleSig = false;
                    });
                }).catch((err) => {
                    // this.errMessage = 'Incorrect username/password';
                    console.log('this is the sig error', err);
                    this.errMessage =  err.response.data;
                    this.errMessage2 = '';
                    this.submitLoading = false;
                    this.sig1 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.loading1 = false;
                    this.success1 = false;
                    this.success2 = false;
                    this.singleSig = false;
                });

            }
            if (signatureEntry == 2 && (this.$store.state.company.type == 'warehouse' ? !this.verifyBulkOrSignleForWarehouse() : this.sig2.name != this.sig1.name) && !this.singleSig) {
                this.loading2 = true;
                this.singleSig = false;
                axios.post('/sign', this.sig2, this.$store.state.header).then(res => {
                    console.log('this is the signature token', res.data);
                    this.$store.dispatch('getRefreshToken');
                    this.sigToken2 = res.data.access_token;
                    // if(res.data.single_signature_primary){
                    //     console.log('this is a single sig primary')
                    //     this.singleSig = true;
                    // } 
                    return res;
                }).then(() => {
                    axios.post('/signature', { signature_token: this.sigToken2, type: 'Witness' }, this.$store.state.header).then(res => {
                        // console.log('this is the signature id for sig 2', res.data);
                        this.$store.dispatch('getRefreshToken');
                        this.signature_2 = res.data.uuid;
                        console.log('this is the signature id for sig 2', this.signature_2);
                        this.loading2 = false;
                        this.success2 = true;
                        if (this.$store.state.company.type == 'warehouse' && this.isStatus?.status ? this.isStatus?.status : (this.isStatus?.status == undefined && (!this.dualForMeds && !this.dual)) ? true : this.signPrimarySignature) {
                            this.submitAction()
                        }else{
                            if((this.dualForMeds || this.dual)){
                                if(this.success2 && this.success1){
                                    this.submitAction()
                                }
                            } else{
                                if(this.success1){
                                    this.submitAction()
                                }
                            }
                        }
                        // this.errMessage = '';
                        // if(res1.data.single_signature_primary){
                        //         console.log('this is a single sig primary')
                        //         this.singleSig = true;
                        //     }
                    }).catch(err => {
                        this.errMessage = err?.response?.data;
                        this.errMessage2 = '';
                        this.submitLoading = false;
                        this.sig2 = {
                            name: '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.loading2 = false;
                        this.success2 = false;
                    });
                }).catch((err) => {
                    // this.errMessage = 'Incorrect username/password';
                    this.errMessage = err?.response?.data;
                    this.errMessage2 = '';
                    this.submitLoading = false;
                    this.sig2 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.loading2 = false;
                    this.success2 = false;
                    // this.singleSig = false;
                });
            }
            if (this.witness) {
                let witnessLoad = {
                    name: this.witnessName,
                    reference_number: this.witnessRefNumber,
                    role: this.witnessRole,
                    type: 'Witness'
                }

                axios.post('/plain-signature', witnessLoad, this.$store.state.header).then(res => {
                    console.log('this is the signature id', res.data);
                    this.$store.dispatch('getRefreshToken');
                    this.signature_2 = res.data.uuid;
                }).catch((err) => {
                    // this.errMessage = 'Incorrect username/password';
                    this.errMessage = err.response.data.errors;
                    this.loading1 = false;
                    this.success1 = false;
                    this.success2 = false;
                    this.singleSig = false;
                });
            }
        },
        focusInput() {
            // Focus the password if username prefilled
            if (this.sig1.name && (this.displayReason ? (this.reason ? true : false) : true) ) {
                this.$refs?.sig1password?.focus();
            }
            // Else focus the username
            else if (this.displayReason ? (this.reason ? true : false) : true){
                this.$refs?.sig1username?.focus();
            }
        },
        authforsignoff() {
            return this.noAuthRequired || (((this.dualForMeds || this.dual) || this.$store.state.user.role.permissions.includes('single_signature_primary')) && (this.success1 || this.success2)) || ((this.optional || this.success2) && this.success1);
        },
        finalSignoffInvoices() {
            if (this.authforsignoff()) {
                this.submitAction()
            }
        },
        warehouseCounterSignCheck(type) {
            // Use cache to avoid redundant calls
            const cacheKey = `type_${type}_permissions_${this.$store.state.user.role.permissions.join('_')}_status_${this.isStatus?.status}`;
            if (this.cachedResults[cacheKey] !== undefined) {
                return this.cachedResults[cacheKey];
            }

            const result = this.warehouseCounterSign(type);
            this.cachedResults[cacheKey] = result; // Cache the result
            return result;
        },

        // Implemented warehouse counter sign functionality based on the signature_primary, signature_witness, and single_signature_primary guards.
        // Displays the signature options based on the user's permissions. 
        // Shows and stores signatures in the `verification` object of the item based on its type (primary, witness, or scheduled_items)
        // if the process is related to a warehouse and the status is bulk.
        // - For 'primary' type items, store `signature_1` and hide `signature_1`.
        // - For 'witness' type items, store `signature_2` and hide `signature_2`.
        warehouseCounterSign(type) {
            const userPermissions = this.$store.state.user.role.permissions;
            const companyType = this.$store.state.company.type;
            const status = this.isStatus?.status;
            const isbulk = this.isStatus?.isbulk;
            const dualForMeds = this.dualForMeds;
            const isWarehouse = this.isWarehouse;
            const isPrimary = userPermissions.includes('signature_primary');
            const isWitness = userPermissions.includes('signature_witness');
            const hasSingleSignaturePrimary = userPermissions.includes('single_signature_primary');

            // Check if the company type and warehouse condition are met
            if (companyType === 'warehouse' && isWarehouse) {
                if (status === "no_single_signature_primary" ||
                    (!hasSingleSignaturePrimary && !dualForMeds)) {
                    this.errMessage = "You do not have single_signature_primary permissions to sign this order, please contact admin.";
                    return undefined;
                }

                if (!isPrimary && !isWitness) {
                    if (hasSingleSignaturePrimary) {
                        if (status === "primary" || status === "witness" || dualForMeds) {
                            this.errMessage = "You do not have signature_primary or signature_witness permissions to sign this order, please contact admin.";
                            return undefined;
                        }
                        return true;
                    }
                    this.errMessage = "You do not have signature_primary or signature_witness or single_signature_primary permissions to sign this order, please contact admin.";
                    return undefined;
                }

                if (isPrimary && isWitness) {
                    if (!this.signPrimarySignature && !status) {
                        return type === 1;
                    }
                    if (status === "primary") {
                        if (!isbulk) {
                            this.sig1 = {
                                name: this.isStatus?.lastSign,
                                password: '',
                                company_id: this.$store.state.company.uuid,
                            };
                            this.signature_1 = this.isStatus?.uuid;
                        }
                        return false;
                    }
                    if (status === "witness") {
                        if (!isbulk) {
                            this.sig2 = {
                                name: this.isStatus?.lastSign,
                                password: '',
                                company_id: this.$store.state.company.uuid,
                            };
                            this.signature_2 = this.isStatus?.uuid;
                        }
                        return true;
                    }
                    return true;
                }

                if (isPrimary && !isWitness) {
                    if (!isbulk) {
                        this.sig2 = {
                            name: this.isStatus?.lastSign,
                            password: '',
                            company_id: this.sig2?.company_id,
                        };
                            
                    }
                    if (status === "primary") {
                        if (!isbulk) {
                            this.signature_1 = this.isStatus?.uuid;
                        }
                        this.errMessage = "You do not have enough permissions to sign this order, please contact admin.";
                        return undefined;
                    }
                    if (status === "witness") {
                        if (!isbulk) {
                            this.signature_2 = this.isStatus?.uuid;
                        }
                        return true;
                    }
                    return true;
                }

                if (!isPrimary && isWitness) {
                    if (!isbulk) {
                        this.sig1 = {
                            name: this.isStatus?.lastSign,
                            password: '',
                            company_id: this.sig1?.company_id,
                        };  
                    }
                    if (status === "witness") {
                        if (!isbulk) {
                            this.signature_2 = this.isStatus?.uuid;                            
                        }
                        this.errMessage = "You do not have enough permissions to sign this order, please contact admin.";
                        return undefined;
                    }
                    if (status === "primary") {
                        if (!isbulk) {
                            this.signature_1 = this.isStatus?.uuid;                            
                        }
                        return false;
                    }
                    return !dualForMeds;
                }
            } else {
                if (type === 1) {
                    return true;
                }
                if (type === 2) {
                    return false;
                }
                return true;
            }
        },
        verifyBulkOrSignleForWarehouse() {
            // Use `some` to check if any name in `this.sig1.name` matches `this.sig2?.name`
            if (this.isStatus?.signData?.length && this.isStatus?.isbulk) {
                const isNameExist = this.sig1.name.some((name) => name === this.sig2?.name);
                return isNameExist
            } else {
                return this.sig2.name == this.sig1.name
            }
        }
    },
    mounted() {
        console.log("payload>>", this.payload2, this.payload, this.isStatus);
                if(this.noAuthRequired){
            this.noAuthSignature();
        }
        if(this.stock_items){
            this.selected_stock_item = this.stock_items[0];
        }
        console.log('this user has a username cached', localStorage.getItem('username'),this.payload);
        if(localStorage.getItem('username')){
            console.log('does have username cached');
            if (this.$store.state.company.type == 'warehouse') {
                if (!this.isStatus?.isbulk && !this.sig1.name) {
                    this.sig1.name = localStorage.getItem('username');
                } else if(this.isStatus?.signData?.length && this.isStatus?.isbulk) {
                    this.sig1.name = this.isStatus?.signData?.map((name) => name?.lastSign);
                }
            } else {
                this.sig1.name = localStorage.getItem('username');
            }
        }
        if(!this.noAuthRequired){
            this.focusInput();
        }
        if(this.manual_loop ){
            let payloads = [];
            if(this.endpoint != '/adjustments'){
                this.payload.drugs.forEach(drug=>{
                    let pay = {...this.payload};
                    pay.drugs = [drug];
                    // let pay = {
                    //     type: this.payload.type,
                    //     to_from: this.payload.to_from,
                    //     drugs: [drug],
                    //     notes: this.payload.notes,
                    //     prescriber_uuid: this.payload.prescriber_uuid,
                    //     patient_uuid: this.payload.patient_uuid
                    // }
                    payloads.push(pay);
                })
            } else{
                console.log('this is the adjustments endpoint')
                this.payload.stock_items.forEach(stock=>{
                    let pay = {...this.payload};
                    pay.stock_items = [stock];
                    payloads.push(pay);
                })
            }
            
            console.log('this is the manual payload restruct', payloads);
            this.payloads  = payloads;
        }
     
    },
    watch: {
        signPrimarySignature(newVal) {
            if (newVal) {
                this.sig2.name = ''
                this.sig2.password = ''
            }
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

 

 

  

.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}

.discard-checkbox{
    height: 1.5em;
    margin: 0;
    padding: 0;
}
.signborder {
    background: none !important;
    border: 1px solid #f3f4f4;
}
.singleSignature {
    flex-direction: row !important;
    margin-left: auto;
    margin-right: 20px;
    align-items: center !important;

    .calenderdatelabel {
        flex-direction: row !important;
        align-items: center !important;
    }
}
</style>